import { render, staticRenderFns } from "./studentRegistered.vue?vue&type=template&id=78a563c1&scoped=true&"
import script from "./studentRegistered.vue?vue&type=script&lang=js&"
export * from "./studentRegistered.vue?vue&type=script&lang=js&"
import style0 from "./studentRegistered.vue?vue&type=style&index=0&id=78a563c1&lang=scss&scoped=true&"
import style1 from "./studentRegistered.vue?vue&type=style&index=1&lang=css&"
import style2 from "./studentRegistered.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./studentRegistered.vue?vue&type=style&index=3&id=78a563c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a563c1",
  null
  
)

export default component.exports